/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Component,
  DestroyRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { getScoreType as resolveScoreType } from 'src/app/shared/utils/score-type-details';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { RoutingService } from 'src/app/service/routing.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PortfolioNameComponent } from '../news-portfolio/portfolio-name/portfolio-name.component';
import { QueryNameComponent } from '../news-query/query-name/query-name.component';
import { DialogTableComponent } from '../../../micro-components/dialog-table/dialog-table.component';
import { AuditData } from 'src/app/cockpit/main-news/news-audit-view/audit-data.service';
import { EntityInfoService } from 'src/app/shared/services/metadata-api/entity-info.service';
import { ConfigService } from 'src/app/service/config.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-audit-title',
  templateUrl: './news-audit-title.component.html',
  styleUrls: ['./news-audit-title.component.scss'],
})
export class NewsAuditTitleComponent implements OnChanges {
  @Input() auditData: AuditData;
  @Input() loading = false;
  params: any;
  previousValue: any;
  theme = 'dark';
  entities: any;
  folio: any;
  folios: any;
  customScore: any;

  constructor(
    public featureFlagsService: FeatureFlagsService,
    private router: Router,
    private route: ActivatedRoute,
    public routing: RoutingService,
    public config: ConfigService,
    public dialog: MatDialog,
    public entityInfoService: EntityInfoService,
    private portfolioApi: PortfolioApiService,
    private destroyRef: DestroyRef,
  ) {
    this.customScore = this.featureFlagsService.scorelabSettings.defaultScore;
    this.route.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.params = params;

        if (this.routing.reFresh(params, this.previousValue, ['score'])) {
          this.customScore = params.score
            ? params.score
            : this.featureFlagsService.scorelabSettings.defaultScore;
        }

        this.theme = this.routing.theme;

        if (
          this.routing.reFresh(params, this.previousValue, [
            'id',
            'groupId',
            'portfolioId',
          ])
        ) {
          if (this.routing.isFolio()) {
            if (this.portfolioApi.portfolios) {
              this.setEntities();
            } else {
              this.entities = [];
            }
          }
        }
        this.previousValue = params;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.auditData && changes.auditData.currentValue) {
      if (this.routing.isFolio() && this.portfolioApi.portfolios) {
        this.setEntities();
      }
    }
  }

  setEntities() {
    if (this.routing.isFolio()) {
      if (this.portfolioApi.portfolios) {
        const portfolioId = this.params.portfolioId
          ? this.params.portfolioId
          : this.params.id;
        this.folio = this.portfolioApi.portfolios.filter((el) => {
          return el.uid === portfolioId;
        })[0];
        const entities = this.folio.content;
        this.entityInfoService.getEntitiesInfo(entities).subscribe((result) => {
          this.entities = Object.values(result).filter((element) => {
            return element !== null;
          });
          this.entities.forEach((item) => {
            item.name =
              item.name !== 'PNE'
                ? item.name
                : item.alpha_id.split('.')[1] +
                  ' (' +
                  item.alpha_id.split('.')[0] +
                  ')';
          });
        });
      } else {
        this.entities = [];
      }
    }
  }

  getScoreType(id?: string): string {
    return resolveScoreType(this.featureFlagsService.scorelabSettings, id);
  }

  appendItem(option: 'add' | 'create') {
    if (this.routing.isMarket()) {
      this.dialog.open(PortfolioNameComponent, {
        data: { action: option, entity: this.auditData.entity },
      });
    }
    if (this.routing.isSearch()) {
      this.dialog.open(QueryNameComponent, {
        data: { action: option, query: this.auditData.entity },
      });
    }
  }
  select(item) {
    if (item === 'overall') {
      if (this.routing.isFolio()) {
        this.auditData.entity.type = 'Portfolio';
        this.auditData.entity.name = this.folio.name;
        this.router.navigate([], {
          queryParams: {
            id: this.params.portfolioId
              ? this.params.portfolioId
              : this.params.id,
            type: null,
            newstype: null,
            portfolioId: null,
            score: null,
            time: this.params.score ? null : this.params.time,
            reflow: Math.random(),
          },
          queryParamsHandling: 'merge',
        });
      }
    } else {
      if (this.routing.isFolio()) {
        this.auditData.entity.type = item.type;
        this.auditData.entity.name = item.name;

        const newParams = {
          id: item.alpha_id,
          type: item.type,
          newstype: null,
          portfolioId: this.params.portfolioId
            ? this.params.portfolioId
            : this.params.id,
          score: null,
          time: this.params.time,
          reflow: Math.random(),
          focused_score: null,
        };
        this.router.navigate([], {
          queryParams: newParams,
          queryParamsHandling: 'merge',
        });
      }
    }
  }

  openDialog(entity: any) {
    this.dialog.open(DialogTableComponent, {
      data: {
        title: 'Sanctions on ' + entity.name,
        table: entity.sanctions.map((sanction: any) => ({
          authority: sanction.sanctioned_by.name,
          authorityId: sanction.sanctioned_by.alpha_id,
          authorityType: sanction.sanctioned_by.type,
          program: sanction.program,
          start: sanction.sanctioned_from,
          end: sanction.sanctioned_to,
        })),
      },
      width: '60%',
    });
  }
}
